import { useTranslation } from 'react-i18next';

export default function HowIIJReducesRisk() {
  const { t } = useTranslation('common');

  return (
    <section className="py-24 px-8 bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            {t('risk.title')}
          </h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto leading-relaxed">
            {t('risk.subtitle')}
          </p>
        </div>

        <div className="mb-16">
          <img 
            src="https://public.readdy.ai/ai/img_res/8cac9743bf489e21d27b1c23c536ad71.jpg" 
            alt="Redundant Network Architecture" 
            className="w-full h-full object-cover object-center rounded-lg"
          />
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-12">
          <div>
            <h3 className="text-2xl font-semibold mb-4">{t('risk.design.title')}</h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              {t('risk.design.paragraph1')}
            </p>
            <p className="text-gray-300 leading-relaxed">
              {t('risk.design.paragraph2')}
            </p>
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-4">{t('risk.integration.title')}</h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              {t('risk.integration.paragraph1')}
            </p>
            <p className="text-gray-300 leading-relaxed">
              {t('risk.integration.paragraph2')}
            </p>
          </div>
        </div>

        <div className="text-center">
          <p className="text-gray-300 leading-relaxed max-w-4xl mx-auto">
            {t('risk.partnership')}
          </p>
        </div>
      </div>
    </section>
  );
}
